"use client";

import { useTrackingRecordSave } from "@/api/track/use-query";
import { AuthorizeContext } from "@/app/AuthorizeProvider";
import { LoginContext } from "@/app/LoginProvider";
import { EventConfig } from "@/hooks/useAddShowcase";
import { TrackingBtnId, TrackingEventID, TrackingEventType } from "@/shared";
import { TProductInfo } from "@/typings";
import React, { useCallback, useContext } from "react";

interface EvokeSkuActionProps {
  children: React.ReactNode;
  product: TProductInfo;
  eventConfig?: EventConfig;
}

const EvokeSkuAction: React.FC<EvokeSkuActionProps> = ({
  children,
  product,
  eventConfig,
}) => {
  const { mutate: fetchTrackingRecordSave } = useTrackingRecordSave();

  const loginCtx = useContext(LoginContext);
  const authorizeCtx = useContext(AuthorizeContext);

  // 点击 free sample 埋点
  const handleEvokeSkuTrack = useCallback(
    (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
      e.preventDefault();
      e.stopPropagation();
      fetchTrackingRecordSave({
        uid: loginCtx?.userInfo?.uid,
        ...(product && { product_id: product.product_id }),
        event_id: TrackingEventID.FreeSample,
        event_type: TrackingEventType.Click,
        btn_id: TrackingBtnId.FreeSample,
        ...eventConfig,
      });
      if (loginCtx?.userInfo) {
        authorizeCtx?.$skuVisible?.(true);
        authorizeCtx?.$product?.(product);
        authorizeCtx?.$eventConfig?.({
          page_id: eventConfig?.page_id,
          btn_id: eventConfig?.btn_id || TrackingBtnId.FreeSample,
          module_id: eventConfig?.module_id,
        });
      } else {
        // 未登录
        loginCtx?.$loginVisible?.(true);
      }
    },
    [fetchTrackingRecordSave, loginCtx, authorizeCtx, product, eventConfig]
  );

  return <span onClick={handleEvokeSkuTrack}>{children}</span>;
};

export default EvokeSkuAction;
